var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('cell-label');
import { breakpoints, theme } from '@shapeable/theme';
export var CellLabelDefaultProps = {
  tag: 'h2',
  variant: 'normal'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: inherit;\n    font-size: ", ";\n    font-weight: 400;\n    margin: 0;\n    text-transform: uppercase;\n\n    ", " \n  "], ["\n    color: inherit;\n    font-size: ", ";\n    font-weight: 400;\n    margin: 0;\n    text-transform: uppercase;\n\n    ", " \n  "])), theme.FONT_SIZE(13), function (_a) {
    var variant = _a.variant;
    return variant === 'form' && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      font-weight: 500;\n      font-size: ", ";\n    "], ["\n      font-weight: 500;\n      font-size: ", ";\n    "])), theme.FONT_SIZE(14));
  })
});
// -------- Components -------->
var My = {
  Container: styled.h2(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var CellLabel = function (props) {
  var className = props.className,
    children = props.children,
    tag = props.tag;
  return (
    // @ts-ignore
    React.createElement(My.Container, {
      as: tag,
      className: cls.name(className)
    }, children)
  );
};
CellLabel.defaultProps = CellLabelDefaultProps;
CellLabel.cls = cls;
var templateObject_1, templateObject_2, templateObject_3;